export default __webpack_public_path__ + "static/media/house_searching.19564c68.svg";